/*
 * @Author: Dong
 * @Date: 2022-05-06 13:26:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-17 12:25:12
 */
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import classnames from 'classnames';
import copy from 'copy-to-clipboard';
import { Button, Switch, Progress, message, Tooltip, Divider, Spin } from 'sup-ui';
import Icon from 'root/components/Icon';
import Modal from 'root/components/CommonModal';
import { syncBack } from 'root/store/actions';
import { formatDate } from 'root/utils/utils';

import { configReducer, initConfig, initModal, modalReducer } from './reducer';
import { infoType } from './types';
import Table from './Table';
import BackupForm from './BackupForm';
import AutoBackupForm from './AutoBackupForm';
import FailureList from './FailureList';
import messages from '../messages';
import styles from './index.less';
import {
  getDiskAndPathInfo,
  postBackupTask,
  getTaskInfo,
  confirmFail,
  postRecoverTask,
  getAutoBackUpConfig,
  setAutoBackUpConfig,
  switchAutoBackUp,
} from 'root/services/syncBack';
import reductionSvg from 'root/assets/images/reduction.svg';
import copySvg from 'root/assets/images/copy.svg';
import { getHostDetailApi } from 'root/services/disk';

const stautsObject = ['init', 'doing', 'success', 'failure'];

let timer: any;
const { confirm } = Modal;

const modalTitles: { [x: string]: MessageDescriptor } = {
  backup: messages.modalBackupTitle,
  back: messages.modalBackTitle,
  set: messages.modalBackupSetTitle,
};

const BusinessSyncBack = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const modalContentRef = useRef<any>();

  const [status, setStatus] = useState<string>(stautsObject[0]); // 备份还原状态
  const [info, setInfo] = useState<infoType>(); // 备份还原信息
  const [visibleDetail, setVisibleDetail] = useState<boolean>(false); // 详情显隐
  const [config, dispatchConfig] = useReducer(configReducer, initConfig);
  const [modal, dispatchModal] = useReducer(modalReducer, initModal); // 弹框信息
  const [failureModalVisble, setFailureModalVisble] = useState(false); // 失败信息弹框显隐
  const [spinning, setSpinning] = useState(false); // 提交备份接口loading
  const [singleNodeId, setSingleNodeId] = useState('');

  useEffect(() => {
    getStatus();
    getDiskInfo();
    getAutoBackUpData(); // 获取自动备份设置
    getHostDetail();
  }, []);

  // 查询磁盘和路径信息
  const getDiskInfo = () => {
    getDiskAndPathInfo().then((res) => {
      dispatchModal({
        type: 'setData',
        params: {
          data: res.data,
        },
      });
    });
  };

  // 获取serverNode
  const getHostDetail = () => {
    getHostDetailApi({ ids: [] }).then((res: any) => {
      const {
        data: { serverNodeBriefs = [] },
      } = res;
      setSingleNodeId(serverNodeBriefs[0]?.id);
    });
  };

  // 查询备份还原状态
  const getStatus = () => {
    getTaskInfo().then((res: any) => {
      const { data } = res;

      const status = data.status === 'NO_TASK' ? 'init' : data.status === 'RUNNING' ? 'doing' : 'success';
      data.type = data.type ? data.type.toLowerCase() : '';
      data.progress = Number(data?.progress);
      setStatus(status);
      setInfo(data);
      dispatchConfig({ type: 'toggleChecked', params: { checked: !!data?.onOff } });

      // 备份还原结束，更新日志记录
      if (['success', 'failure'].includes(status)) {
        dispatch(syncBack.getLogRecord());
      }

      // 进行中或者开启自动备份并且非失败，轮询查状态
      if (status === 'doing' && !data.failed) {
        loopStatus();
      }
      // 备份失败
      if (data.failed && !data.userConfirm) {
        setFailureModalVisble(true);
        return;
      }
      setFailureModalVisble(false);
    });
  };

  // 获取自动备份配置
  const getAutoBackUpData = () => {
    getAutoBackUpConfig().then((res) => {
      const { data } = res;
      dispatchConfig({ type: 'setConfig', params: { ...data } });
    });
  };

  // 轮询查状态
  const loopStatus = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      getStatus();
    }, 5000);
  };

  // 开关自动备份
  const handleChangeOpen = (checked: boolean) => {
    // 状态为: 从关到开,显示配置弹框
    if (checked) {
      return toggleVisible({ type: 'set', isFromSwitch: true });
    }
    // 状态为: 从开到关,不显示配置弹窗
    hanleSwitchAutoBackUp(checked);
  };

  // 自动备份开关调接口
  const hanleSwitchAutoBackUp = (onOff: boolean) => {
    switchAutoBackUp({ onOff: Number(onOff) })
      .then((res: any) => {
        const { result, config } = res.data;
        if (result) {
          // 接口成功之后在更改状态
          dispatchConfig({ type: 'toggleChecked', params: { checked: onOff } });
          onOff && dispatchConfig({ type: 'setConfig', params: { ...config } });
        } else {
          message.error(intl.formatMessage(messages.autoBackupFail));
        }
      })
      .catch(() => {
        message.error(intl.formatMessage(messages.autoBackupFail));
      });
  };

  const toggleVisible = (params = {}) => {
    dispatchModal({ type: 'toggleVisible', params: params });
  };

  // 显示备份弹框
  const handleBackupPrev = (type: string) => {
    // TODO 传递数据
    toggleVisible({ type: type });
  };

  // 显示还原弹框
  const handleBackPrev = (type: string) => {
    toggleVisible({ type: type });
  };

  // 显示备份设置弹框
  const handleSetPrev = (type: string) => {
    toggleVisible({ type: type, isFromSwitch: false });
  };

  // 确认备份
  const handleBackup = (err: boolean, values: any) => {
    if (err) return;
    const params = {
      ...values,
      serverNodeId: singleNodeId,
    };
    setSpinning(true);
    postBackupTask(params)
      .then(() => {
        toggleVisible();
        dispatch(syncBack.getLogRecord());
        getStatus();
      })
      .finally(() => {
        setSpinning(false);
      });
  };

  // 确认还原
  const handleBack = (err: boolean, values: any) => {
    if (err) return message.warn(intl.formatMessage(messages.modalBackTitle));

    confirm({
      content: (
        <span className={styles.confirmBack}>{intl.formatMessage(messages.confirmBack, { type: values.taskIds })}</span>
      ),
      onOk: () => {
        postRecoverTask({ file: values.taskIds, serverNodeId: singleNodeId }).then(() => {
          toggleVisible();
          dispatch(syncBack.getLogRecord());
          getStatus();
        });
      },
    });
  };

  // 确认备份设置
  const handleSet = (err: boolean, values: any) => {
    if (err) return;
    const params = {
      ...values,
      startTime: new Date(values.startTime).getTime(),
    };
    // 第一种: 单纯的设置,不需要调打开接口
    setAutoBackUpConfig(params)
      .then((res) => {
        if (res?.data.result) {
          message.success(intl.formatMessage(messages.setAutoBackupFail));
          return;
        }
        message.success(intl.formatMessage(messages.setAutoBackupSuccess));
        // 第二种: 需要调打开接口
        modal.isFromSwitch ? hanleSwitchAutoBackUp(true) : getAutoBackUpData();
      })
      .catch((err) => {
        message.error(err?.data?.message || intl.formatMessage(messages.setAutoBackupFail));
      })
      .finally(() => {
        toggleVisible();
      });
  };

  const modalShowPrevFn: { [x: string]: (arg0: any) => void } = {
    backup: handleBackupPrev,
    back: handleBackPrev,
    set: handleSetPrev,
  };

  const modalOkFn: { [x: string]: (err: boolean, values: any) => void } = {
    backup: handleBackup,
    back: handleBack,
    set: handleSet,
  };

  const clickBtn = (type: string) => {
    if (!type || !modalShowPrevFn[type]) return;

    modalShowPrevFn[type](type);
  };

  // 保存配置
  const handleOk = () => {
    if (!modal.type || !modalOkFn[modal.type] || !modalContentRef.current.validateFields) return;

    modalContentRef?.current.validateFields((err: boolean, values: any) => {
      modalOkFn[modal.type](err, values);
    });
  };

  // 复制文件路径
  const copyPath = () => {
    if (!info?.path) return;

    copy(info?.path);
    message.success(intl.formatMessage(messages.successCopy));
  };

  // 显隐详情
  const toggleVisibleDetail = () => {
    setVisibleDetail(!visibleDetail);
  };
  // 点击知道了
  const gotIt = () => {
    confirmFail().then(() => {
      getStatus();
      dispatch(syncBack.getLogRecord());
    });
  };

  const toggleFailureVisible = () => {
    setFailureModalVisble(false);
  };
  const renderModal: { [x: string]: React.ReactNode } = {
    // 备份弹框
    backup: <BackupForm ref={modalContentRef} data={modal.data} />,
    // 还原弹框
    back: <Table ref={modalContentRef} />,
    // 自动备份设置弹框
    set: <AutoBackupForm ref={modalContentRef} data={config?.config} />,
    // 失败弹框
    failure: <FailureList data={info?.logs || []} />,
  };

  const renderStatus: { [x: string]: React.ReactNode } = {
    // 未备份
    init: (
      <div className={styles.noBackupData}>
        <span>{intl.formatMessage(messages.noBackupData)}</span>
        <div className={styles.btnGroup}>
          <Button size="small" onClick={() => clickBtn('backup')} type="primary">
            {intl.formatMessage(messages.backup)}
          </Button>
          <Button size="small" onClick={() => clickBtn('back')}>
            {intl.formatMessage(messages.back)}
          </Button>
          <Button size="small" onClick={() => clickBtn('set')}>
            {intl.formatMessage(messages.set)}
          </Button>
        </div>
      </div>
    ),
    // 进行中
    doing: (
      <div className={styles.doingBackup}>
        <ul className={styles.detailBox}>
          <li className={styles.titleBox}>
            <img src={info?.type === 'backup' ? copySvg : reductionSvg} className={styles.backSvg} />
            <span title={info?.taskName}>{info?.taskName}</span>
            <span className={styles.percent}>{info?.progress}%</span>
            <span className={styles.time}>
              {intl.formatMessage(info?.type === 'backup' ? messages.startBackupTime : messages.startBackTime)}:
              {formatDate(info?.startTime)}
            </span>
          </li>
          {/* <li>
            {intl.formatMessage(info?.type === 'backup' ? messages.startBackupTime : messages.startBackTime)} :{' '}
            {formatDate(info?.startTime)}
          </li> */}
        </ul>
        <Progress showInfo={false} strokeWidth={4} strokeColor="#2280fa" percent={info?.progress || 0} />
        <div className={styles.detailOpt}>
          <span className={styles.detailStep}>
            {/* {intl.formatMessage(messages.doingBackup)} */}
            {info?.logs?.[info?.logs.length - 1]?.detail}
          </span>

          {/* 本次迭代不做自动备份 暂时隐藏 */}
          <span className={styles.logDownload} style={{ display: 'none' }}>
            {intl.formatMessage(messages.logDownload)}
          </span>
          <span
            className={classnames(styles.detailToggle, { [`${styles.showDetailList}`]: visibleDetail })}
            onClick={toggleVisibleDetail}
          >
            {intl.formatMessage(messages.detail)}
            <Icon type={visibleDetail ? 'bluearrow16_up' : 'bluearrow16_down'} />
          </span>
        </div>
        {visibleDetail && (
          <ul className={styles.detailList}>
            {info?.logs?.map((item) => {
              return (
                <li key={item.id}>
                  <span style={{ paddingRight: 10 }}>
                    {item.finishTime ? formatDate(item.finishTime) : formatDate(item.startTime)}
                  </span>
                  <span>{item.detail}</span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    ),
    // 成功
    success: (
      <div className={styles.successBackup}>
        <div className={styles.infoBox}>
          <span>
            {intl.formatMessage(messages.lastBackupTime)} : {formatDate(info?.finishTime)}
          </span>
          <div className={styles.btnGroup}>
            <Button size="small" onClick={() => clickBtn('backup')} type="primary">
              {intl.formatMessage(messages.backup)}
            </Button>
            <Button size="small" onClick={() => clickBtn('back')}>
              {intl.formatMessage(messages.back)}
            </Button>

            <Button size="small" onClick={() => clickBtn('set')}>
              {intl.formatMessage(messages.set)}
            </Button>
          </div>
        </div>
        <ul className={styles.detailBox}>
          <li>
            {intl.formatMessage(messages.filePath)} : {info?.path}
            <Icon className={styles.copyIcon} type="copy16" onClick={copyPath} />
          </li>
          <li>
            {intl.formatMessage(messages.fileSize)} : {info?.fileSize}
          </li>
          <li>
            {intl.formatMessage(messages.diskFreeSpace)} : {info?.disk}
          </li>
        </ul>
      </div>
    ),
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {intl.formatMessage(messages.businessDataSyncBack)}
        <Tooltip title={intl.formatMessage(messages.business)} overlayClassName={styles.TooltipBox}>
          <div>
            <Icon type="tip16" className={styles.titleTipIcon} />
          </div>
        </Tooltip>
      </h2>
      <div className={styles.content}>
        {renderStatus[status]}
        <Divider />
        <div className={styles.switchBox}>
          <span>{intl.formatMessage(messages.autoBackup)}</span>
          <Switch disabled={status === 'doing'} size="small" checked={config.checked} onChange={handleChangeOpen} />
        </div>
        {config.checked && (
          <ul className={styles.detailBox}>
            <li>
              {intl.formatMessage(messages.nextSyncTime)}: {formatDate(config.config?.nextRunTime, 'YYYY-MM-DD')}
            </li>
            <li>
              {intl.formatMessage(messages.startTime)}: {formatDate(config.config?.startTime, 'HH:mm:ss')}
            </li>
            <li>
              {intl.formatMessage(messages.syncTimes)}: {config.config?.intervalTimes}
              {intl.formatMessage(messages.syncTimesUnit)}
            </li>
            <li>
              {intl.formatMessage(messages.saveCount)}: {config.config?.retainCount}
            </li>
          </ul>
        )}
      </div>
      <Modal
        visible={modal.visible}
        title={modalTitles[modal.type] && intl.formatMessage(modalTitles[modal.type])}
        className={styles.modal}
        onOk={handleOk}
        onCancel={toggleVisible}
        height="auto"
        width="556px"
        destroyOnClose
      >
        <Spin spinning={spinning}>{renderModal[modal.type]}</Spin>
      </Modal>

      <Modal
        visible={failureModalVisble}
        closable={false}
        title={
          <span>
            <Icon type="tixing40" className={styles.failureIcon} />
            {info && info.type === 'backup'
              ? intl.formatMessage(messages.backupFailed)
              : intl.formatMessage(messages.recoverFailed)}
          </span>
        }
        className={styles.modal}
        onCancel={toggleFailureVisible}
        height="auto"
        width="556px"
        destroyOnClose
        footer={
          <Button type="primary" onClick={gotIt}>
            {intl.formatMessage(messages.gotIt)}
          </Button>
        }
      >
        {info?.logs?.length ? renderModal['failure'] : <span className={styles.confirmBack}>{info?.failedMsg}</span>}
      </Modal>
    </div>
  );
};

export default BusinessSyncBack;
